import React from "react";
import { Link } from "react-router-dom";
import * as Config from "./../../constants/Config";
import { category } from "../../api/tmdbApi";
import apiConfig from "../../api/apiConfig";
import "./movie-card.scss";

const MovieCard = (props) => {
  const item = props.item;

  const link =
    "/" + Config.HOME_PAGE + "/" + category[props.category] + "/" + item.id;

  const poster = apiConfig.w500Image(item.poster_path || item.backdrop_path);

  // 🔹 Date handle (movie = release_date, tv = first_air_date)
  const date = item.release_date || item.first_air_date || null;

  // Year only
  const year = date ? new Date(date).getFullYear() : "----";

  // Full date (optional: if you want exact date)
  const formatDate = (d) => {
    if (!d) return "----";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(d).toLocaleDateString("en-US", options);
  };
 const displayDate = formatDate(date);

  // Rating
  const rating = item.vote_average ? item.vote_average.toFixed(1) : "N/A";

  return (
    <Link to={link}>
      <p>{displayDate}</p>
      <div className="movie-card">
        {/* Poster */}
        <div className="poster">
          <img src={poster} alt={item.title || item.name} />
        </div>

        {/* Info */}
        <div className="movie-info">
          <h3 className="title">{item.title || item.name}</h3>
          <div className="meta">
            {/* Year only → {year} */}
            {/* Or show full date → {displayDate} */}
            <span className="year">{year}</span>
            <span className="rating">⭐ {rating}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default MovieCard;
